// Generated by CoffeeScript 1.12.7
(function() {
  var VASTIcon;

  VASTIcon = (function() {
    function VASTIcon() {
      this.program = null;
      this.height = 0;
      this.width = 0;
      this.xPosition = 0;
      this.yPosition = 0;
      this.apiFramework = null;
      this.offset = null;
      this.duration = 0;
      this.type = null;
      this.staticResource = null;
      this.htmlResource = null;
      this.iframeResource = null;
      this.iconClickThroughURLTemplate = null;
      this.iconClickTrackingURLTemplates = [];
      this.iconViewTrackingURLTemplate = null;
    }

    return VASTIcon;

  })();

  module.exports = VASTIcon;

}).call(this);



//////////////////
// WEBPACK FOOTER
// ../~/vast-client/dist/icon.js
// module id = 66
// module chunks = 0